// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton {
	position: relative;
	overflow: hidden;
	background-size: 200% 100%;
	animation: shimmer 2s ease-in-out infinite;
}

@keyframes shimmer {
	0% {
		background-position: 100% 0;
	}
	100% {
		background-position: -100% 0;
	}
}
`, "",{"version":3,"sources":["webpack://./../../packages/py-components/src/components/atoms/Skeleton/Skeleton.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,0BAA0B;CAC1B,0CAA0C;AAC3C;;AAEA;CACC;EACC,2BAA2B;CAC5B;CACA;EACC,4BAA4B;CAC7B;AACD","sourcesContent":[".skeleton {\n\tposition: relative;\n\toverflow: hidden;\n\tbackground-size: 200% 100%;\n\tanimation: shimmer 2s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n\t0% {\n\t\tbackground-position: 100% 0;\n\t}\n\t100% {\n\t\tbackground-position: -100% 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
